import * as React from 'react';
import styled from 'styled-components';
import { Text } from 'office-ui-fabric-react';
import { CSSProperties } from 'react';
import { IFontStyles } from 'office-ui-fabric-react';

const Styled = {
  Title: styled.h1`
    min-height: 66px;
    margin: 0;
    span {
      display: flex;
      align-items: center;
      color: #5f5d5b;
    }
  `,
};

interface IProps {
  style?: CSSProperties;
  variant?: keyof IFontStyles;
}

const Title: React.FC<IProps> = ({ children, style, variant = 'xxLarge' }) => {
  return (
    <Styled.Title style={style}>
      <Text variant={variant}>{children}</Text>
    </Styled.Title>
  );
};

export default Title;
